import Vue from 'vue'
const url = window.$website.url
const request = Vue.prototype.$axios;
// const baseUrl = url + '/record'
const baseUrl = '/dtv/api/next/public/dataset'

export const getList = (params) => request({
  url: baseUrl + '/get/page/by/condition',
  method: 'get',
  params: { cmd: params }
});



export const getObj = (id) => request({
  url: baseUrl + '/get/by/id',
  method: 'get',
  params: {
    id
  }
});

export const addObj = (data) => request({
  url: baseUrl + '/do/create',
  method: 'post',
  data: data
});
export const updateObj = (data) => request({
  url: baseUrl + '/do/update',
  method: 'post',
  data: data
});



export const delObj = (id) => request({
  url: baseUrl + '/do/delete/by/id',
  method: 'delete',
  data: [id]
});